export default __webpack_public_path__ + "static/media/bedding_dark.09b53731.png";